import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { JoveChatCoversationTypeEnum } from '@jove-frontend/enums';
import { JoveTextField } from '@jove-frontend/mui';
import { REQUEST_SUCCESS_CODE, apiCMSGetCustomerServiceChatCoversationList } from '@jove-frontend/uikit';
import { SearchOutlined } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Tab, Tabs, Typography } from '@mui/material';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import ConversationListItem from './item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AIChatCoversationListView = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$emptyText = props.emptyText,
      emptyText = _props$emptyText === void 0 ? 'No conversations' : _props$emptyText,
      onConversationSelect = props.onConversationSelect,
      selectedConversationItem = props.selectedConversationItem,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? 'transparent' : _props$backgroundColo,
      coversationListChange = props.coversationListChange;

  var _useState = useState(JoveChatCoversationTypeEnum.ai),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = useState(false),
      tabLoading = _useState2[0],
      setTabLoading = _useState2[1];

  var _useState3 = useState([]),
      visibleConversations = _useState3[0],
      setVisibleConversations = _useState3[1];

  var _useState4 = useState(''),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];
  /**
   * requests
   */


  var requestConversationList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tabValue) {
      var params, _yield$apiCMSGetCusto, _yield$apiCMSGetCusto2, res, _res$data, _list;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                conversation_type: tabValue,
                offset: 0,
                limit: 100
              };

              if (inputValue) {
                params['search'] = inputValue;
              }

              setTabLoading(true);
              _context.next = 5;
              return apiCMSGetCustomerServiceChatCoversationList(params);

            case 5:
              _yield$apiCMSGetCusto = _context.sent;
              _yield$apiCMSGetCusto2 = _slicedToArray(_yield$apiCMSGetCusto, 1);
              res = _yield$apiCMSGetCusto2[0];

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                _list = ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || []).map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    id: uniqueId()
                  });
                });
                setVisibleConversations(_list);
                coversationListChange === null || coversationListChange === void 0 ? void 0 : coversationListChange(_list);
              }

              setTabLoading(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestConversationList(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    requestConversationList(activeTab);
  }, []);
  /**
   * methods
   */

  var inputValueChangeAction = function inputValueChangeAction(value) {
    setInputValue(value);
  };

  var tabChangeAction = function tabChangeAction(e, value) {
    setActiveTab(value);
    requestConversationList(value);
  };
  /**
   * external methods
   */


  useImperativeHandle(ref, function () {
    return {
      markConversationItemRead: markConversationItemRead,
      refreshList: refreshList,
      increaseCoversationUnreadCount: increaseCoversationUnreadCount,
      updateCoversationItemInfo: updateCoversationItemInfo
    };
  });

  var markConversationItemRead = function markConversationItemRead(item) {
    var index = visibleConversations.findIndex(function (aItem) {
      return aItem.id === item.id;
    });

    if (index !== -1) {
      visibleConversations[index] = _objectSpread(_objectSpread({}, visibleConversations[index]), {}, {
        unread_count: 0
      });
      setVisibleConversations(_toConsumableArray(visibleConversations));
    }
  };

  var refreshList = function refreshList() {
    requestConversationList(activeTab);
  };

  var increaseCoversationUnreadCount = function increaseCoversationUnreadCount(conversationData) {
    var _ref2 = conversationData || {},
        email = _ref2.email;

    setVisibleConversations(function (prev) {
      return prev.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          unread_count: (item.unread_count || 0) + (email === item.email ? 1 : 0)
        });
      });
    });
  };

  var updateCoversationItemInfo = function updateCoversationItemInfo(conversationData) {
    setVisibleConversations(function (prev) {
      return prev.map(function (item) {
        return conversationData.id === item.id ? _objectSpread(_objectSpread({}, item), conversationData) : item;
      });
    });
  };

  var isLoading = loading || tabLoading;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex h-full flex-col', className),
    sx: {
      backgroundColor: backgroundColor,
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        backgroundColor: 'transparent',
        px: 1.5,
        pt: 1.25,
        pb: 0.75
      },
      children: /*#__PURE__*/_jsxs(Tabs, {
        value: activeTab,
        onChange: tabChangeAction,
        variant: "standard",
        TabIndicatorProps: {
          sx: {
            display: 'none'
          }
        },
        sx: {
          minHeight: 42,
          backgroundColor: 'transparent',
          '& .MuiTabs-flexContainer': {
            gap: 1
          },
          '& .MuiTab-root': {
            minHeight: 42,
            textTransform: 'none',
            fontSize: '0.95rem',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            color: '#64748B',
            borderRadius: '999px',
            transition: 'background-color 180ms ease, color 180ms ease, transform 180ms ease',
            backgroundColor: 'transparent',
            border: '1px solid transparent',
            minWidth: 0,
            px: 2,
            '&:hover': {
              backgroundColor: 'rgba(37, 99, 235, 0.06)',
              color: '#1D4ED8'
            }
          },
          '& .MuiTab-root.Mui-selected': {
            color: '#1D4ED8',
            backgroundColor: 'rgba(37, 99, 235, 0.12)',
            borderColor: 'rgba(37, 99, 235, 0.18)'
          }
        },
        children: [/*#__PURE__*/_jsx(Tab, {
          value: JoveChatCoversationTypeEnum.ai,
          label: "AI",
          sx: {
            minWidth: 60,
            px: 1.75
          }
        }), /*#__PURE__*/_jsx(Tab, {
          value: JoveChatCoversationTypeEnum.agent,
          label: "Human Service",
          sx: {
            minWidth: 140,
            px: 2.5
          }
        })]
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row px-3 py-1",
      children: [/*#__PURE__*/_jsx(JoveTextField, {
        className: "flex-1",
        label: "Search by phone or email",
        size: "small",
        placeholder: "",
        value: inputValue,
        valueChange: inputValueChangeAction,
        showClearBtn: true
      }), /*#__PURE__*/_jsx(IconButton, {
        onClick: function onClick() {
          return requestConversationList(activeTab);
        },
        children: /*#__PURE__*/_jsx(SearchOutlined, {
          className: "text-brand-secondary cursor-pointer"
        })
      })]
    }), isLoading && /*#__PURE__*/_jsx(Box, {
      className: "flex flex-1 items-center justify-center",
      sx: {
        minHeight: '200px'
      },
      children: /*#__PURE__*/_jsx(CircularProgress, {
        size: 40
      })
    }), !isLoading && visibleConversations.length === 0 && /*#__PURE__*/_jsx(Box, {
      className: "flex flex-1 items-center justify-center",
      sx: {
        minHeight: '200px'
      },
      children: /*#__PURE__*/_jsx(Typography, {
        sx: {
          color: '#9CA3AF',
          fontSize: '0.95rem'
        },
        children: emptyText
      })
    }), !isLoading && visibleConversations.length > 0 && /*#__PURE__*/_jsx(Box, {
      className: "flex-1 overflow-y-auto",
      sx: {
        '&::-webkit-scrollbar': {
          width: '8px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#E5E7EB',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: '#D1D5DB'
          }
        }
      },
      children: /*#__PURE__*/_jsx(Box, {
        className: "space-y-2 p-3",
        children: visibleConversations.map(function (item, index) {
          return /*#__PURE__*/_jsx(ConversationListItem, {
            info: item,
            className: clsx((selectedConversationItem === null || selectedConversationItem === void 0 ? void 0 : selectedConversationItem.id) === item.id ? 'border-2 border-blue-500 ring-2 ring-blue-100' : 'border border-transparent hover:border-slate-200'),
            isSelected: (selectedConversationItem === null || selectedConversationItem === void 0 ? void 0 : selectedConversationItem.id) === item.id,
            onClick: function onClick() {
              return onConversationSelect === null || onConversationSelect === void 0 ? void 0 : onConversationSelect(item);
            }
          }, item.id);
        })
      })
    })]
  });
});
export default AIChatCoversationListView;